import React from 'react';
import Layout from "../components/App/Layout"
import SEO from "../components/App/SEO"
import NavbarStyleTwo from '../components/App/NavbarStyleTwo';
import PageBanner from '../components/Common/PageBanner';
import Footer from '../components/App/Footer';
import StartProjectWithUs from '../components/Common/StartProjectWithUs';

import ServicesImg1 from '../assets/images/nlp/2.png'
import ServicesImg2 from '../assets/images/nlp/1.png'
import ServicesImg3 from '../assets/images/nlp/3.png'

const SingleServices = () => {
    return (
        <Layout>
            <SEO title="Natural Language AI" description="Design AI products that process data from structured and unstructured sources to identify patterns and generate predictive insights."/>

			<NavbarStyleTwo />

			<PageBanner 
                pageTitle="Natural Language AI" 
            /> 

<div className="overview-area ptb-100">
                <div className="container">
                    <div className="overview-box">
                        
                    <div className="overview-content">
                            <div className="content right-content">
                                <span className="sub-title">Identify Patterns. Attribute Meaning. </span>
                                <h2>Diagnostic NLP</h2>
                                <p>Design applications that process data from unstructured sources, identify patterns and attribute meaning.</p>
                                <ul className="features-list">
                                    <li><span><i className='bx bx-check'></i> Sentiment Analysis</span></li>
                                    <li><span><i className='bx bx-check'></i> Topic Modelling</span></li>
                                    <li><span><i className='bx bx-check'></i> Intent Classification</span></li>
                                    <li><span><i className='bx bx-check'></i> Events Detection</span></li>
                                

                                </ul>
                            </div>
                        </div>

                        <div className="overview-image">
                            <div className="image">
                                <img src={ServicesImg1} alt="image" />
                            </div>
                        </div>
                    </div>

                    <div className="overview-box">
                        <div className="overview-image">
                            <div className="image">
                                <img src={ServicesImg2} alt="image" />
                            </div>
                        </div>
                        
                        <div className="overview-content">
                            <div className="content right-content">
                                <span className="sub-title">A Deep Dive into content analysis</span>
                                <h2>Descriptive NLP </h2>
                                <p>Build applications that can summarize large volumes of text and make it easier for consumption and decision making.</p>
                                <ul className="features-list">
                                    <li><span><i className='bx bx-check'></i> Keyphrase Extraction</span></li>
                                    <li><span><i className='bx bx-check'></i> Custom Classification </span></li>
                                    <li><span><i className='bx bx-check'></i> Content Summarization</span></li>
                                    <li><span><i className='bx bx-check'></i> PII Identification and Redaction</span></li>
                                
                                    

                                </ul>
                            </div>
                        </div>
                        <div className="overview-box">
                        
                        <div className="overview-content">
                                <div className="content right-content">
                                    <span className="sub-title">Predict what's next with AI</span>
                                    <h2>Predictive NLP</h2>
                                    <p>Design mobile and web applications powered by Large Language Models to create intelligent and creative applications.</p>
                                    <ul className="features-list">
                                        <li><span><i className='bx bx-check'></i> AI-powered Copywriting </span></li>
                                        <li><span><i className='bx bx-check'></i> Medical Ontology Linking </span></li>
                                        <li><span><i className='bx bx-check'></i> Next Word Prediction</span></li>
                                        <li><span><i className='bx bx-check'></i> Translate English into Code</span></li>
                                    

                                    </ul>
                                </div>
                            </div>
    
                            <div className="overview-image">
                                <div className="image">
                                    <img src={ServicesImg3} alt="image" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="services-area bg-f9f9f9 pt-100 pb-70">
                <div className="container">
                    <div className="section-title">
                        <span className="sub-title">DERIVE MEANING FROM CONTENT</span>
                        <h2>Core Application Areas</h2>
                        <p>Here are a few areas where Natural Language AI can be used to improve efficiency and drive productivity.</p>
                    </div>

                    <div className="row">
                        <div className="col-lg-4 col-md-6 col-sm-6">
                            <div className="single-services-box">
                                <div className="icon">
                                    <i className="bx bx-clinic"></i>
                                    <div className="circles-box">
                                        <div className="circle-one"></div>
                                        <div className="circle-two"></div>
                                    </div>
                                </div>
                                <h3>Healthcare</h3>
                                <p>Diagnostic intelligence, prescription assistance, prediction engines, automated transcription, & much more.</p>
                            </div>
                        </div>

                        <div className="col-lg-4 col-md-6 col-sm-6">
                            <div className="single-services-box">
                                <div className="icon">
                                    <i className="bx bx-book-reader"></i>
                                    <div className="circles-box">
                                        <div className="circle-one"></div>
                                        <div className="circle-two"></div>
                                    </div>
                                </div>
                                <h3>Legal & Compliance</h3>
                                <p>Legal judgement prediction, similar case matching, dynamic legal assistance , intelligent data mining & more.</p>
                            </div>
                        </div>

                        <div className="col-lg-4 col-md-6 col-sm-6">
                            <div className="single-services-box">
                                <div className="icon">
                                    <i className="bx bx-slideshow"></i>
                                    <div className="circles-box">
                                        <div className="circle-one"></div>
                                        <div className="circle-two"></div>
                                    </div>
                                </div>
                                <h3>Media & PR</h3>
                                <p>Brand reputation measurement, content personalization, automated transcript generation, sentiment analysis & more.</p>
                            </div>
                        </div>

                        <div className="col-lg-4 col-md-6 col-sm-6">
                            <div className="single-services-box">
                                <div className="icon">
                                    <i className="bx bx-support"></i>
                                    <div className="circles-box">
                                        <div className="circle-one"></div>
                                        <div className="circle-two"></div>
                                    </div>
                                </div>
                                <h3>Customer Support</h3>
                                <p>CSAT measurement, call pattern identification, customer pain point mapping, defect rate calculation & much more.</p>
                            </div>
                        </div>

                        <div className="col-lg-4 col-md-6 col-sm-6">
                            <div className="single-services-box">
                                <div className="icon">
                                    <i className="bx bx-bot"></i>
                                    <div className="circles-box">
                                        <div className="circle-one"></div>
                                        <div className="circle-two"></div>
                                    </div>
                                </div>
                                <h3>Smart Assistants</h3>
                                <p>Build a multilingual engine that can power smart assistants to carry out instructions based on text and voice inputs .</p>
                            </div>
                        </div>

                        <div className="col-lg-4 col-md-6 col-sm-6">
                            <div className="single-services-box">
                                <div className="icon">
                                    <i className="bx bx-search-alt"></i>
                                    <div className="circles-box">
                                        <div className="circle-one"></div>
                                        <div className="circle-two"></div>
                                    </div>
                                </div>
                                <h3>Search Engines</h3>
                                <p>Build next generation applications with intelligent search that delivers relevant content in milliseconds.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            

            <StartProjectWithUs />
			  
			<Footer />
		</Layout>
    )
}

export default SingleServices;